import {Component, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Validators, FormGroup, FormControl, AbstractControl, ValidationErrors} from '@angular/forms';
import {WebService} from '../services/web/web.service';
import {ToastService} from '../services/notification/toast.service';
import {SpinnerService} from '../services/spinner/spinner.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Location, DatePipe} from '@angular/common';
import {MatDialogRef, MatDialog} from '@angular/material/dialog';
import {PortalService} from '../account-settings/portal/my-portals/portal.service';
import { HttpClient } from '@angular/common/http';
import {TableService} from '../services/pager/pager';
import {AppConfirmService} from "../app-confirm/app-confirm.service";
import {SecurityService} from "../services/security.service";
import {UserPermissionsService} from "../services/user-permissions.service";

@Component({
    selector: 'app-customer-update',
    templateUrl: './customer-update.component.html',
    styleUrls: ['./customer-update.component.scss'],
    providers: [DatePipe, AppConfirmService],
    standalone: false
})
export class CustomerUpdateComponent implements OnInit {

    form: FormGroup;
    exist: Boolean = false;
    isNewService: Boolean = true;

    taxes: any[] = [{value: true, description: "SI"}, {value: false, description: 'NO'}];
    customer: any;
    private originalEmail: string | null = null;
    addresses: any[] = [];
    suscriptions: any[] = [];


    // PARA MANEJO DE TABLAS
    @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
    @ViewChild(MatSort) sort: MatSort | undefined;
    displayedColumns: string[] = ['suscription', 'adress', 'actions'];
    dataSource: any;


    constructor(
        private securityService: SecurityService,
        private confirmService: AppConfirmService,
        public tableService: TableService<any>,
        private cdr: ChangeDetectorRef,
        private datePipe: DatePipe,
        private http: HttpClient,
        private dialog: MatDialog,
        private location: Location,
        private portalService: PortalService,
        private activateRoute: ActivatedRoute,
        private router: Router,
        private spinner: SpinnerService,
        private webService: WebService,
        private toast: ToastService,
        private userPermissionsService: UserPermissionsService) {
        this.form = new FormGroup({
            id: new FormControl('', [
                Validators.required
            ]),
            name_customer: new FormControl('', [
                Validators.required
            ]),
            lastName_customer: new FormControl('', [
                Validators.required
            ]),
            code_customer: new FormControl('', [
                Validators.required,
                CustomerUpdateComponent.notBlank
            ]),
            identifier_customer: new FormControl('', [
                Validators.required,
                Validators.pattern(/^[A-Za-z0-9-]+$/)
            ]),
            email_customer: new FormControl('', [
                Validators.email
            ]),
            phoneNumber_customer: new FormControl('', [Validators.pattern(/^[0-9]{7,14}$/)]),
            adress_customer: new FormControl(''),
            birthDate_customer: new FormControl(''),
            status_customer: new FormControl('', [
                Validators.required
            ]),
            sucursal_id: new FormControl(''),
            taxexempt: new FormControl(''),
        });
    }

    private static notBlank(control: AbstractControl): ValidationErrors | null {
        const value = control.value;
        return typeof value === 'string' && value.length > 0 && value.trim().length === 0 ? {required: true} : null;
    }

    ngOnInit(): void {

        this.activateRoute.params.subscribe(params => {


            //Se carga la informacion del cliente seleccionado para la actualizacion
            this.webService.get(this.webService.HOST + "/partner/" + this.securityService.getTokenPartner() + "/customer/" + params["id"]).subscribe(customer => {
                this.customer = customer.result;
                //Se llenan los componentes del formulario con la informacion
                this.form.controls["id"].setValue(this.customer.id);
                this.form.controls["name_customer"].setValue(this.customer.name_customer);
                this.form.controls["lastName_customer"].setValue(this.customer.lastName_customer);
                this.originalEmail = this.customer.email_customer ?? null;
                this.form.controls["code_customer"].setValue(this.customer.code_customer ?? '');
                this.form.controls["adress_customer"].setValue(this.customer.adress_customer);
                this.form.controls["phoneNumber_customer"].setValue(this.customer.phoneNumber_customer);
                this.form.controls["birthDate_customer"].setValue(this.customer.birthDate_customer);
                this.form.controls["email_customer"].setValue(this.customer.email_customer);
                this.form.controls["identifier_customer"].setValue(this.customer.identifier_customer);
                this.form.controls["sucursal_id"].setValue(this.customer.sucursal_id);
                this.form.controls["status_customer"].setValue(this.customer.status_customer);
                this.form.controls["taxexempt"].setValue(this.customer.taxexempt);

                this.webService.get(this.webService.HOST + "/hasplan/partner/" + this.securityService.getTokenPartner() + "/customer/" + params["id"]).subscribe(suscriptions => {
                    this.suscriptions = [];
                    for (let s of suscriptions.result) {
                        if (s.adress_id != null) {
                            this.suscriptions.push(s);
                            this.spinner.open();
                            this.webService.get(this.webService.HOST + "/adress/" + s.adress_id).subscribe(address => {
                                let index = this.suscriptions.findIndex(t => t.id == s.id)
                                this.suscriptions[index].address = address.result;
                                this.dataSource = new MatTableDataSource<any>(this.suscriptions);
                                this.tableService.selection.clear();
                                this.spinner.close();
                            }, err => {
                                console.log(err);
                                this.spinner.close();
                            });
                        } else {
                            this.dataSource = new MatTableDataSource<any>(this.suscriptions);
                            this.tableService.selection.clear();
                            this.spinner.close();
                        }
                    }

                }, err => {
                    console.log(err);
                })


            }, err => {
                this.spinner.close();
                this.toast.showError(err);
                setTimeout(() => {
                    this.location.back();
                }, 2000); // 3000 milliseconds = 3 seconds
            });
        });


    }

    updateAddress(row: any) {
        this.router.navigate(['./address/' + row.address.id], {
            relativeTo: this.activateRoute,
            queryParamsHandling: 'preserve'
        });
    }

    update() {
        if (!this.canUpdateCustomer()) {
            return this.toast.showWarning("No tienes permisos para actualizar clientes.");
        }

        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return this.toast.showInfo("Por favor complete el formulario de Datos generales");
        }
        this.customer = this.form.value;
        this.customer.partner = {id: +this.securityService.getTokenPartner()};
        this.customer.birthDate_customer = this.datePipe.transform(this.customer.birthDate_customer, 'yyyy-MM-dd');
        console.log(this.customer);
        if ((this.customer.email_customer ?? null) == this.originalEmail) {
            this.updateCustomer();
        } else {
            this.confirmService.confirm({
                title: 'Confirmación',
                message: " Este cambio afectará el correo de acceso del cliente. ¿Desea continuar?"
            })
                .subscribe(res => {
                    if (res) {
                        this.updateCustomer();
                    }
                })
        }
    }

    updateCustomer() {
        if (!this.canUpdateCustomer()) {
            return this.toast.showWarning("No tienes permisos para actualizar clientes.");
        }

        this.spinner.open();
        // Se actualiza la informacion del cliente
        this.webService.put(this.customer, this.webService.HOST + "/partner/" + this.securityService.getTokenPartner() + "/customer/" + this.customer.id).subscribe(customer => {
            this.spinner.close()
            this.toast.showSuccess("Cliente actualizado correctamente");
            this.location.back();
        }, (err) => {
            this.spinner.close();
            console.log(err);
            this.toast.showError(err);
        });
    }

    goBack() {
        this.router.navigate(["/reports"]);
    }

    omit_special_char(event: { charCode: any; }) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

   onlyNumberKey(event: any) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    canUpdateCustomer(): boolean {
        return this.userPermissionsService.hasPermission("controllers.Customers.update");
    }

}
